import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getDefaultAuthenticatedPath } from "@/utils/permissions";

export default function Home() {
	const navigate = useNavigate();
	const { user, loading } = useAuth();

	useEffect(() => {
		if (loading) {
			return; // espera o auth carregar
		}

		if (user) {
			navigate(getDefaultAuthenticatedPath(user.role), { replace: true });
		} else {
			navigate("/login", { replace: true }); // rota pública
		}
	}, [loading, user, navigate]);

	return (
		<div className="flex min-h-screen items-center justify-center bg-primary">
			<div className="flex flex-col items-center gap-4">
				<div className="h-12 w-12 animate-spin rounded-full border-4 border-white border-t-transparent" />
				<p className="text-lg text-white">Carregando...</p>
			</div>
		</div>
	);
}
